/* eslint-disable max-depth */
/* eslint-disable array-callback-return */
import { ActionRuleParams } from '../../types';
import { hasKitchenReferenceRule } from '../../helpers';

export const fridge21TrimKitC121s = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { panelItemGroups, panelItemGroup } = refMap;
	const runRule = hasKitchenReferenceRule({ refMap, rule: 'Fridge21TrimKitC121s' });
	if (runRule) {
		const eligibleItems = panelItemGroups.children.map((group) => group.items.children.filter((item) => item.item.component.rules.action.includes('Fridge21TrimKitC121s')))
			.filter((group) => group.length > 0);
		const fridgeSupportPromos = refMap.kitchen.itemizedMsrp.items.filter((item) => item.sku === 'CRTA21TK');
		let newTrim = null;
		if (eligibleItems.length > fridgeSupportPromos.length) {
			newTrim = panelItemGroup.items.newFromSku('CRTA21TK');
			eligibleItems.forEach((item) => {
				if (item) {
					item.forEach((i) => {
						console.log('trim added to', i);
					});
				}
			});
			const existingItemCenters = panelItemGroups.children
				.flatMap((group) => group.items.children)
				.map((item) => item.center);

			if (!existingItemCenters.includes(newTrim.center)) {
				panelItemGroup.items.delete(newTrim.id);
				newTrim = null;
			}
		} else {
			panelItemGroup.items.children.forEach((item) => {
				if (item.item.sku === 'CRTA21TK') {
					panelItemGroup.items.delete(item.id);
				}
			});
		}
	}
};
